export default __webpack_public_path__ + "static/media/upload_file.d69c64e6.svg";